import { render, staticRenderFns } from "./MaterialMng.vue?vue&type=template&id=7b039c94&scoped=true"
import script from "./MaterialMng.vue?vue&type=script&lang=js"
export * from "./MaterialMng.vue?vue&type=script&lang=js"
import style0 from "./MaterialMng.vue?vue&type=style&index=0&id=7b039c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b039c94",
  null
  
)

export default component.exports